import ajaxService from "./ajax-service";

class SubscriptionService {
    /**
     * Get subscriptions list with filters
     * @param {Object} params - Query parameters
     * @param {number} params.per_page - Items per page (default: 15)
     * @param {string} params.search - Search by user name/email
     * @param {string} params.status - Filter by status (active, expired)
     * @param {string} params.start_date - Start date filter (YYYY-MM-DD)
     * @param {string} params.end_date - End date filter (YYYY-MM-DD)
     * @param {string} params.sort_by - Sort field (e.g., 'created_at')
     * @param {string} params.sort_order - Sort order ('asc' or 'desc')
     * @param {number} params.page - Page number for pagination
     */
    async getSubscriptions(params = {}) {
        const queryParams = new URLSearchParams();

        if (params.per_page) queryParams.append('per_page', params.per_page);
        if (params.search) queryParams.append('search', params.search);
        if (params.status) queryParams.append('status', params.status);
        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);
        if (params.sort_by) queryParams.append('sort_by', params.sort_by);
        if (params.sort_order) queryParams.append('sort_order', params.sort_order);
        if (params.page) queryParams.append('page', params.page);

        const queryString = queryParams.toString();
        const url = `/admin/subscriptions${queryString ? '?' + queryString : ''}`;

        return ajaxService.get(url);
    }

    /**
     * Get subscription details by ID
     * @param {number} id - Subscription ID
     */
    async getSubscription(id) {
        return ajaxService.get(`/admin/subscriptions/${id}`);
    }

    /**
     * Get subscription statistics
     * @param {Object} params - Query parameters
     * @param {string} params.start_date - Start date (YYYY-MM-DD)
     * @param {string} params.end_date - End date (YYYY-MM-DD)
     */
    async getSubscriptionStats(params = {}) {
        const queryParams = new URLSearchParams();

        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);

        const queryString = queryParams.toString();
        const url = `/admin/subscriptions/stats${queryString ? '?' + queryString : ''}`;

        return ajaxService.get(url);
    }

    /**
     * Get subscription analytics data
     * @param {Object} params - Query parameters
     * @param {number} params.period - Period in months (default: 12)
     */
    async getSubscriptionAnalytics(params = {}) {
        const queryParams = new URLSearchParams();

        if (params.period) queryParams.append('period', params.period);

        const queryString = queryParams.toString();
        const url = `/admin/subscription-analytics${queryString ? '?' + queryString : ''}`;

        return ajaxService.get(url);
    }
}

const subscriptionService = new SubscriptionService();

export default subscriptionService;
